<template>
    <div class="mhelp">
        <div class="mhtittle">
            <h1>帮助中心</h1>
            <div class="input">
                <input type="text" placeholder="输入问题关键词，最多13字">
                <mu-icon size="30" value="search" color="grey500" style=" position: absolute;top: 35%;right: 1.25rem;"></mu-icon>
            </div>
        </div>
        <ul>
            <li>
                <mu-icon size="18" value="airplay" color="red" class="mlogo"></mu-icon>
                <span>安装前准备</span>
            </li>
            <li>
                <mu-icon size="18" value="settings" color="blue" class="mlogo"></mu-icon>
                <span>配置前准备</span>
            </li>
            <li>
                <mu-icon size="18" value="share" color="green" class="mlogo"></mu-icon>
                <span>绑定对接公众号</span>
            </li>
            <li>
                <mu-icon size="18" value="adjust" color="indigo400" class="mlogo"></mu-icon>
                <span>对接授权小程序</span>
            </li>
        </ul>
        <p>常见问题分类汇总</p>
        <mu-container>
            <mu-expansion-panel :expand="panel === 'panel1'" @change="toggle('panel1')" style="margin-bottom: 1rem">
                <div slot="header" style="position: relative;width: 100%"><mu-icon class="lastlogo" size="22" value="business" color="blue"></mu-icon><span>安装前须知</span></div>
                <p class="litem">EWEISHOP安装前准备</p>
            </mu-expansion-panel>
            <mu-expansion-panel :expand="panel === 'panel2'" @change="toggle('panel2')" style="margin-bottom: 1rem">
                <div slot="header" style="position: relative;width: 100%"><mu-icon class="lastlogo" size="22" value="business" color="blue"></mu-icon><span>配置前准备</span></div>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
            </mu-expansion-panel>
            <mu-expansion-panel :expand="panel === 'panel3'" @change="toggle('panel3')" style="margin-bottom: 1rem">
                <div slot="header" style="position: relative;width: 100%"><mu-icon class="lastlogo" size="22" value="business" color="blue"></mu-icon><span>常见问题</span></div>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
            </mu-expansion-panel>
            <mu-expansion-panel :expand="panel === 'panel4'" @change="toggle('panel4')" style="margin-bottom: 1rem">
                <div slot="header" style="position: relative;width: 100%"><mu-icon class="lastlogo" size="22" value="business" color="blue"></mu-icon><span>管理端</span></div>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
            </mu-expansion-panel>
            <mu-expansion-panel :expand="panel === 'panel5'" @change="toggle('panel5')" style="margin-bottom: 1rem">
                <div slot="header" style="position: relative;width: 100%"><mu-icon class="lastlogo" size="22" value="business" color="blue"></mu-icon><span>业务端</span></div>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
            </mu-expansion-panel>
            <mu-expansion-panel :expand="panel === 'panel6'" @change="toggle('panel6')" style="margin-bottom: 1rem">
                <div slot="header" style="position: relative;width: 100%"><mu-icon class="lastlogo" size="22" value="business" color="blue"></mu-icon><span>更新日志</span></div>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
                <p class="litem">EWEISHOP安装前准备</p>
            </mu-expansion-panel>
            <div class="fooder">
                <div>微涟科技有限公司版权所有</div>
                <div>©辽ICP备18009739号</div>
            </div>
        </mu-container>

    </div>
</template>
<script>
    export default {
        name: 'mhelp',
        data () {
            return {
                panel: ''
            }
        },
        methods: {
            toggle (panel) {
                this.panel = panel === this.panel ? '' : panel;
            }
        }

    }
</script>
<style scoped>
    .mhelp{
        width: 100%;
        position: relative;
        top: 3rem;

    }
    .mhelp h1{
        color: #fff;
        margin: 0;
        font-size: 1.15rem;
        font-weight: 500;
        line-height: 2.35rem;
        padding-top: 0.5rem;
    }
    .mhtittle{
        background: #fb6638;
        height: 7.25rem;
    }
    .input{
        padding: 0.7rem 0.65rem;
        height: 3.4rem;
        background: #fb6638;
        overflow: hidden;
        position: relative;
    }
    .input>input{
        border-radius: 0;
        line-height: 1rem;
        width: 100%;
        height: 3rem;
        margin-bottom: 0.75rem;
        padding: 0.5rem 0.4rem;
        font-size: 0.9rem;
        outline: none;
        background-color: #fff;
        color: #444;
        outline: none;
        border: 0px;
    }
    .mhelp>ul{
        margin: 0.9rem 0.6rem;
        overflow: hidden;
    }
    .mhelp>ul>li{
        color: #333;
        width: calc(50% - 2rem);
        height: 3.5rem;
        line-height: 3.5rem;
        font-size: 0.7rem;
        margin-bottom: 0.5rem;
        float: left;
        -webkit-box-shadow: 0 0.01rem 0.8rem #eaeaea;
        box-shadow: 0 0.01rem 0.8rem #eaeaea;
        margin-left: 1rem;
        box-sizing: border-box;
        position: relative;
    }
    .mhelp>ul>li>span{
        font-size: .6rem;
        margin-left:1rem ;
    }
    .mlogo{
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        left: .5rem;
    }
    .mhelp>p{
        font-size: 1.2rem;
        color: #333;
        text-align: center;
    }
    .lastlogo{
        position: absolute;
        top: 0px;
        bottom: 0;
        margin: auto;
        left: 0;
    }
    .litem{
        line-height: 1.95rem;
        color: #666;
        font-size: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
    }
    .fooder{
        padding-top: 0.9rem;
        position: absolute;
        bottom: -9rem;
        text-align: center;
        line-height: 0.9rem;
        height: 3.45rem;
        font-size: 0.4rem;
        background: #f7f7f7;
        color: #999;
        width: 90%;
        margin-bottom: 5rem;
    }
    ul,li{
        list-style: none;
        margin: 0;
        padding: 0;
    }

</style>
</style>


// WEBPACK FOOTER //
// src/components/phone/mhelp.vue